export default "/_next/static/images/effect-left-1-8c144762d7a275269380086fbbaed808.svg";